const SIDE_RULES: Record<string, string> = {
  r: "[&[data-side=right][data-starting-style]]:-translate-x-2 [&[data-side=right][data-ending-style]]:-translate-x-2",
  l: "[&[data-side=left][data-starting-style]]:translate-x-2 [&[data-side=left][data-ending-style]]:translate-x-2",
  t: "[&[data-side=top][data-starting-style]]:translate-y-2 [&[data-side=top][data-ending-style]]:translate-y-2",
  b: "[&[data-side=bottom][data-starting-style]]:-translate-y-2 [&[data-side=bottom][data-ending-style]]:-translate-y-2"
}

export type PopupTransitionOptions = {
  /* Subset of r, l, t, b indicating which sides should animate, defaults to all four. */
  sides?: string
}

/**
 * Shared entry/exit animation for BaseUI popup surfaces (Tooltip, Menu,
 * Popover, NavigationFlyout, etc.).
 *
 * Pairs with any BaseUI component whose Popup element exposes:
 *   - `data-side` — "top" | "bottom" | "left" | "right"
 *   - `data-starting-style` — present for one frame after mount
 *   - `data-ending-style` — present during unmount
 *
 * Emits the full popup animation as a single class string:
 *   - `transition-[opacity,translate]`
 *   - `duration-150` and `ease-out`
 *   - `data-[starting-style]:opacity-0` / `data-[ending-style]:opacity-0`
 *   - Side-relative translate rules keyed off `data-side`
 */
export function popupTransition({
  sides = "rltb"
}: PopupTransitionOptions = {}): string {
  const sideRules = [...sides]
    .map(side => SIDE_RULES[side])
    .filter(Boolean)
    .join(" ")

  return [
    "transition-[opacity,translate] duration-150 ease-out",
    "data-[starting-style]:opacity-0 data-[ending-style]:opacity-0",
    sideRules
  ]
    .filter(Boolean)
    .join(" ")
}
